'use client';
import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component
import 'ag-grid-enterprise';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RangeSelectionModule } from '@ag-grid-enterprise/range-selection';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { RichSelectModule } from '@ag-grid-enterprise/rich-select';
import { ModuleRegistry } from '@ag-grid-community/core';
import Loader from '../../shared/component/Loader';
import apiServices from '../../services/service';
import newui from '../../assets/img/newui2.svg';
import AddUiPermissionsForm from './addUiPermissionsForm';

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  RangeSelectionModule,
  RowGroupingModule,
  RichSelectModule,
]);

const initialValue = {
  permissionValue: '',
  permissionDisplayName: '',
  permissionTypeId: '',
  permissionParentId: null,
  moduleId: '',
  isActive: null,
};

const OptionButton = ({ handleClickOpenEditForm, paramsValue }) => {
  return (
    <div className="action-menu">
      <img
        src="/assets/images/edit.png"
        className="action-img1"
        onClick={() => handleClickOpenEditForm(paramsValue)}
        alt="Edit Permission"
        title="Edit Permission"
      ></img>
    </div>
  );
};

function UiPermissionsList() {
  const gridRef = useRef(); // Optional - for accessing Grid's API
  const [rowData, setRowData] = useState();
  const [open, setOpen] = React.useState(false);
  const [isGetList, setIsGetList] = useState(true);
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);
  const [uiPermissionData, setUiPermissionData] = useState();
  const [loading, setLoading] = useState(false);
  const [updateListFlag, setUpdateListFlag] = useState(false);
  const [permissionType, setPermissionType] = useState([]);
  const [permissionModule, setPermissionModule] = useState([]);
  const [permissionParent, setPermissionParent] = useState([]);
  const [masterPermissionValues, setMasterPermissionValues] = useState([]);
  const [masterPermissionNames, setMasterPermissionNames] = useState([]);
  const [selectedTheme, setSelectedTheme] = useState('balham');

  useEffect(() => {
    // Retrieve user information from local storage
    const userData = JSON.parse(localStorage.getItem('userInformation'));
    // Check if userData is available and contains roles
    if (userData && userData.roles && userData.roles.length > 0) {
      // Extract role names from roles array
      const names = userData.roles.map((role) => role.roleName);
      // Update state with role names
    } else {
      console.error('User data or roles not found.');
    }
  }, []);

  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: 'Actions',
      cellRenderer: (params) => {
        const paramsValue = { ...params.data };
        return (
          <OptionButton
            rowData={paramsValue}
            openPopup={open}
            handleClickOpenEditForm={() => handleClickOpenEditForm(paramsValue)}
          />
        );
      },

      maxWidth: 82,
      minWidth: 82,
      sortable: false,
      filter: false,
      pinned: 'left',
      lockPosition: 'left',
    },

    {
      headerName: 'Module',
      field: 'moduleName',
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Permission Type',
      field: 'permissionTypeName',
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Permission Parent',
      field: 'permissionParentName',
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Permission Value',
      field: 'permissionValue',
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Display Name',
      field: 'permissionDisplayName',
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    },
    {
      headerName: 'Active',
      field: 'isActive',
      filter: false, // Disable filtering on this column
      cellRenderer: (params) => {
        return <input type="checkbox" checked={params.value} disabled />; // Render a disabled checkbox
      },
    },
  ]);

  const defaultColDef = useMemo(() => ({
    sortable: true,
    editable: false,
    flex: 1,
    minWidth: 130,
    filter: true,
    resizable: false,
    enableValue: true,
    // enableRowGroup: true,
    enablePivot: true,
  }));
  const statusBar = useMemo(() => {
    return {
      statusPanels: [
        { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' },
        { statusPanel: 'agTotalRowCountComponent', align: 'center' },
        { statusPanel: 'agFilteredRowCountComponent' },
        { statusPanel: 'agSelectedRowCountComponent' },
        { statusPanel: 'agAggregationComponent' },
      ],
    };
  }, []);

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          minWidth: 225,
          width: 225,
          maxWidth: 225,
        },
        {
          id: 'filters',
          labelDefault: 'Filters',
          labelKey: 'filters',
          iconKey: 'filter',
          toolPanel: 'agFiltersToolPanel',
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
      ],
      position: 'left',
      // defaultToolPanel: 'filters',
      defaultToolPanel: 'none', //show off filter tab bydefault.
    };
  }, []);
  const cellClickedListener = useCallback((event) => { }, []);
  const onFilterTextBoxChanged = useCallback(() => {
    gridRef.current.api.setQuickFilter(document.getElementById('filter-text-box').value);
  }, []);
  const popupParent = useMemo(() => {
    return document.body;
  }, []);
  const onFirstDataRendered = useCallback((params) => {
    gridRef.current.api.paginationGoToPage();
  }, []);
  const sortingOrder = useMemo(() => {
    return ['desc', 'asc', null];
  }, []);

  //method for filter on groups
  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 200,
      pinned: 'left',
    };
  }, []);

  const handleOpenAddForm = () => {
    const updatedObject = {
      ...initialValue,
      type: 'add',
    };
    setUiPermissionData(updatedObject);
    setOpen(true);
  };

  const handleClickOpenEditForm = (paramsValue) => {
    const updatedObject = {
      ...paramsValue,
      type: 'edit',
    };
    setUiPermissionData(updatedObject);
    setOpen(true);
  };
  const handleCloseAddForm = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (isGetList || updateListFlag) {
      setLoading(true);
      {
        apiServices
          .getUiPermissionList()
          .then((response) => {
            if (response.status === 200) {
              const uiPermissionList = response.data.uiPermissionList;
              setRowData(uiPermissionList);
              setUpdateListFlag(false);
              setIsGetList(false);
              setLoading(false);
            } else {
              // Handle other status codes here
              toast.error(`An unexpected error occurred: ${response.status}`, {
                position: 'top-right',
              });
              setLoading(false);
            }
          })
          .catch((error) => {
            // Handle errors
            console.error('Error uploading file:', error);
            setLoading(false);
            //toast.error('An unexpected error occurred.', { position: "top-right"  });
          })
          .finally(() => {
            setLoading(false);
          });
      }
    }
  }, [isGetList, updateListFlag]);

  useEffect(() => {
    setLoading(true);
    apiServices
      .getUiPermissionsType()
      .then((response) => {
        if (response.status === 200) {
          const PermissionValueDropdown = response.data.authReferenceLookups;
          setIsGetList(false);
          setPermissionType(PermissionValueDropdown);
          setLoading(false);
        }
      })

      .catch((error) => {
        console.error('Error:', error);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    apiServices
      .getUiPermissionsModule()
      .then((response) => {
        if (response.status === 200) {
          const PermissionModuleDropdown = response.data.authReferenceLookups;
          setIsGetList(false);
          setPermissionModule(PermissionModuleDropdown);
          setLoading(false);
        }
      })

      .catch((error) => {
        console.error('Error:', error);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    apiServices
      .getUiPermissionsParent()
      .then((response) => {
        if (response.status === 200) {
          const PermissionParentDropdown = response.data.uiPermissionList;
          setIsGetList(false);
          setPermissionParent(PermissionParentDropdown);
          setLoading(false);
        }
      })

      .catch((error) => {
        console.error('Error:', error);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleFormSubmit = (formData) => {
    setLoading(true);
    const {
      type,
      moduleId,
      moduleName,
      permissionParentId,
      permissionParentName,
      permissionTypeId,
      permissionTypeName,
      permissionValue,
      ...updatedFormData
    } = formData;
    if (formData.type === 'edit') {
      apiServices
        .updateUiPermissions(updatedFormData)
        .then((response) => {
          if (response.status === 200) {
            setOpen(false);
            setUpdateListFlag(true);
            setLoading(false);
            toast.success('Permissions updated successfully!', { position: 'top-right' });
          } else {
            const errorMessages = [];
            setLoading(false);
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error('An unexpected error occurred.', { position: 'top-right' });
        });
    } else {
      apiServices
        .addUiPermissions(formData)
        .then((response) => {
          if (response.status === 200) {
            setOpen(false);
            setUpdateListFlag(true);
            setLoading(false);
            toast.success('Permissions created successfully!', { position: 'top-right' });
          } else {
            setOpen(false);
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })
        .catch((error) => {
          //setOpen(false);
          setLoading(false);
          toast.error('An unexpected error occurred.', { position: 'top-right' });
        });
    }
  };

  return (
    <>
      {' '}
      {loading && <Loader />}
      <div className="inner-page" style={containerStyle}>
        {/* <ToastContainer /> */}
        <div className="dash-container">
          <div className="tbl_container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12">
                <div className="main-hd">
                  <div className="pagetitle">
                    <img src="../assets/images/role-management-icons/left-arrow.png" alt="" />
                    UI Permissions
                  </div>

                  <div className="third-div mobView">
                    <div className="dsk">
                      <input
                        className="form-control"
                        id="filter-text-box"
                        type="Text"
                        placeholder="Search in UI Permissions..."
                        onInput={onFilterTextBoxChanged}
                      />
                    </div>
                    <button className="add-btn" type="button" onClick={handleOpenAddForm}>
                      <img src={newui} alt="add-action-permission" />
                      New UI Permission
                    </button>

                    {open && (
                      <div id="dropdown_modal">
                        <div className="modal show" tabIndex="-1" style={{ display: 'block' }}>
                          <AddUiPermissionsForm
                            handleCloseAddForm={handleCloseAddForm}
                            handleFormSubmit={handleFormSubmit}
                            handleClickOpenEditForm={handleClickOpenEditForm}
                            uiPermissionData={uiPermissionData}
                            open={open}
                            permissionType={permissionType}
                            permissionModule={permissionModule}
                            permissionParent={permissionParent}
                            masterPermissionValues={masterPermissionValues}
                            masterPermissionNames={masterPermissionNames}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>{' '}
                <div className="mob mb-3">
                  <input
                    className="form-control"
                    id="filter-text-box"
                    type="Text"
                    placeholder="Search in UI Permissions..."
                    onInput={onFilterTextBoxChanged}
                  />
                </div>
                <div className="cutome_ag_theme">
                  <div
                    className={`ag-theme-${selectedTheme} tbl_height`}
                    style={{ width: '100%', height: `100%` }}
                  >
                    <AgGridReact
                      className="ag-grid-container" // Add a class for styling
                      domLayout="fixedHeight"
                      ref={gridRef} // Ref for accessing Grid's API
                      rowData={rowData} // Row Data for Row
                      columnDefs={columnDefs}
                      autoGroupColumnDef={autoGroupColumnDef}
                      defaultColDef={defaultColDef} // Default Column Properties
                      overlayLoadingTemplate={`<Loader />`}
                      animateRows={true} // Optional - set to 'true' to have rows animate when sorted
                      rowSelection={'multiple'} // Options - allows click selection of rows
                      statusBar={statusBar}
                      sideBar={sideBar} // pass side by making interface
                      enableRangeSelection={true}
                      suppressExcelExport={true}
                      suppressRowClickSelection={true}
                      groupSelectsChildren={true}
                      pivotPanelShow={'always'}
                      popupParent={popupParent}
                      onFirstDataRendered={onFirstDataRendered}
                      onCellClicked={cellClickedListener} // Optional - registering for Grid Event
                      rowDragManaged={true}
                      suppressMoveWhenRowDragging={true} // to mange the design behaviour during the drag a column.
                      alwaysShowVerticalScroll={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UiPermissionsList;
